"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _lodash = require("lodash");

var _constants = require("../shared/constants");

var _interfaces = require("../shared/interfaces");

var _logger = _interopRequireDefault(require("../utils/logger"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var XApiEventService = /*#__PURE__*/function () {
  function XApiEventService() {
    (0, _classCallCheck2.default)(this, XApiEventService);
    (0, _defineProperty2.default)(this, "ampEventsInstance", void 0);
    (0, _defineProperty2.default)(this, "captureEvents", void 0);
    (0, _defineProperty2.default)(this, "messagesPerChannel", void 0);
    (0, _defineProperty2.default)(this, "userId", void 0);
    (0, _defineProperty2.default)(this, "stashedCountsKey", void 0);
    (0, _defineProperty2.default)(this, "contextExtensions", void 0);
    (0, _defineProperty2.default)(this, "resultExtensions", void 0);
    this.ampEventsInstance = null;
    this.captureEvents = false;
    this.messagesPerChannel = {}; // Wrap public methods in try/catch so that eventing errors do not cause user-facing failures.

    this.init = this.wrap(this.init.bind(this), 'init');
    this.aggregateMessages = this.wrap(this.aggregateMessages.bind(this), 'aggregateMessages');
    this.handleSubscriptionEvents = this.wrap(this.handleSubscriptionEvents.bind(this), 'handleSubscriptionEvents');
    this.setContextExtensions = this.wrap(this.setContextExtensions.bind(this), 'setContextExtensions');
    this.logStartClass = this.wrap(this.logStartClass.bind(this), 'logStartClass');
    this.logEndClass = this.wrap(this.logEndClass.bind(this), 'logEndClass');
    this.logJoinClass = this.wrap(this.logJoinClass.bind(this), 'logJoinClass');
    this.logLeaveClass = this.wrap(this.logLeaveClass.bind(this), 'logLeaveClass');
    this.logClassTimeout = this.wrap(this.logClassTimeout.bind(this), 'logClassTimeout');
  }
  /**
   * Initialize the service and set the AmpEvents instance to enable events tracking for realtime messages.
   * Throws on incorrect instance or library version
   */


  (0, _createClass2.default)(XApiEventService, [{
    key: "init",
    value: function init(ampEventsInstance, userId) {
      var _ampEventsInstance$ev;

      if (ampEventsInstance && !((_ampEventsInstance$ev = ampEventsInstance.eventService) !== null && _ampEventsInstance$ev !== void 0 && _ampEventsInstance$ev.addContextExtensions)) {
        _logger.default.error('amp-events@4.0.0 or greater is required to capture xAPI events. Please update amp-events.');

        return;
      }

      if (!ampEventsInstance) {
        _logger.default.warn('AmpEvents has not been instantiated. Realtime messaging events will not be captured.');
      }

      this.messagesPerChannel = {};
      this.ampEventsInstance = ampEventsInstance;
      this.captureEvents = !!ampEventsInstance;
      this.userId = userId;
      this.stashedCountsKey = "stashedRealtimeMessageCounts-".concat(userId);
      this.configureAutoformatting(); // Update messagesPerChannel to match any previous state stored in localStorage.

      this.restoreMessageCounts();
      this.flushMessageCountCache();
    }
    /**
     * For the provided channel, increment the total number of [messageType] messages sent or received.
     * Once the threshold is reached, send a single event representing the batch.
     */

  }, {
    key: "aggregateMessages",
    value: function aggregateMessages(channelName, verb, messageType) {
      var path = [channelName, verb, messageType];
      var existingMessageCount = (0, _lodash.get)(this.messagesPerChannel, path, 0);
      var newMessageCount = existingMessageCount + 1;
      (0, _lodash.set)(this.messagesPerChannel, path, newMessageCount); // If we've reached the batch size, update localStorage counts after the event is sent and counts are reset.

      if (newMessageCount === _constants.EVENT_BATCH_SIZE) {
        this.sendRealtimeMessageEvent(channelName, verb, messageType, newMessageCount);
      } else if (this.captureEvents) {
        this.stashMessageCounts();
      }
    }
    /**
     * Iterate over a list of channels; for each channel, emit an xAPI event for the provided subscription verb
     * (subscribe/unsubscribe). Also stash a synthetic presence-sent event in messagesPerChannel.
     */

  }, {
    key: "handleSubscriptionEvents",
    value: function handleSubscriptionEvents(channelNames, subscriptionVerb, presenceEventType) {
      var _this = this;

      if (!this.captureEvents) {
        return;
      }

      channelNames.forEach(function (channel) {
        var objectId = _interfaces.xAPIObject.Channel;
        var objectDefinition = {
          key: 'channel-name',
          value: channel
        };

        _this.emitChannelEvent(channel, subscriptionVerb, objectId, objectDefinition);

        if (presenceEventType) {
          _this.aggregateMessages(channel, _interfaces.xAPIVerb.Sent, presenceEventType);
        }
      });
    }
    /**
     * Set xAPI event context extensions for user events.
     */

  }, {
    key: "setContextExtensions",
    value: function setContextExtensions(contextExtensions) {
      this.contextExtensions = contextExtensions;
    }
    /**
     * Set xAPI event result extensions for user events.
     */

  }, {
    key: "setResultExtensions",
    value: function setResultExtensions(resultExtensions) {
      this.resultExtensions = resultExtensions;
    }
    /**
     * Emit a startClass event when a teacher starts a class.
     */

  }, {
    key: "logStartClass",
    value: function logStartClass(context) {
      this.emitClassEvent(_interfaces.xAPIVerb.Started, context);
    }
    /**
     * Emit an endClass event when a teacher ends a class.
     */

  }, {
    key: "logEndClass",
    value: function logEndClass(context) {
      this.emitClassEvent(_interfaces.xAPIVerb.Ended, context);
    }
    /**
     * Emit a joinClass event when a student receives a realtime message prompting
     * them to join a started class.
     */

  }, {
    key: "logJoinClass",
    value: function logJoinClass(context) {
      this.emitClassEvent(_interfaces.xAPIVerb.Joined, context);
    }
    /**
     * Emit a leaveClass event when a student receives a realtime message prompting
     * them to leave a started class.
     */

  }, {
    key: "logLeaveClass",
    value: function logLeaveClass(context) {
      this.emitClassEvent(_interfaces.xAPIVerb.Left, context);
    }
    /**
     * Emit a timedOut event when a class session times out.
     */

  }, {
    key: "logClassTimeout",
    value: function logClassTimeout(context) {
      this.emitClassEvent(_interfaces.xAPIVerb.TimedOut, context);
    }
    /**
     * Configure amp-events to skip auto-formatting of channel names.
     */

  }, {
    key: "configureAutoformatting",
    value: function configureAutoformatting() {
      if (!this.captureEvents) {
        return;
      }

      if (this.ampEventsInstance.updateFormattingAllowList) {
        this.ampEventsInstance.updateFormattingAllowList({
          object: {
            definition: {
              keys: ['channel-name']
            }
          },
          context: {
            extensions: {
              keys: ['channel-name', 'live-class-session-id']
            }
          }
        });
      } else {
        _logger.default.warn('Cannot configure auto-formatting for xAPI events. Consider updating to amp-events version 4.1.1 or higher');
      }
    }
    /**
     * Format and send an xAPI event tracking message counts on a channel.
     */

  }, {
    key: "sendRealtimeMessageEvent",
    value: function sendRealtimeMessageEvent(channelName, verb, messageType, messageCount) {
      var _this2 = this;

      if (!this.captureEvents) {
        return;
      }

      var objectId = _interfaces.xAPIObject.RealtimeMessage;
      var objectDefinition = {
        key: 'message-type',
        value: messageType
      };
      var contextExtensions = {
        'message-count': messageCount
      };
      this.emitChannelEvent(channelName, verb, objectId, objectDefinition, contextExtensions).then(function () {
        // Subtract the recorded count from the current to account for any
        // new messages have been sent asynchronously.
        _this2.messagesPerChannel[channelName][verb][messageType] -= messageCount;

        _this2.stashMessageCounts();
      }).catch(function () {
        _logger.default.warn('Error sending the event. Message counts have been retained.');
      });
    }
    /**
     * Build and return an xAPI event with the given details.
     */

  }, {
    key: "buildEvent",
    value: function buildEvent(_ref) {
      var verb = _ref.verb,
          object = _ref.object,
          contextExtensions = _ref.contextExtensions,
          resultExtensions = _ref.resultExtensions;
      var event = this.ampEventsInstance.eventService.createEvent();
      this.ampEventsInstance.eventService.addVerb(event, verb);

      if (contextExtensions) {
        this.ampEventsInstance.eventService.addContextExtensions(event, contextExtensions);
      }

      if (resultExtensions) {
        this.ampEventsInstance.eventService.addResultExtensions(event, resultExtensions);
      }

      if (object) {
        this.ampEventsInstance.eventService.addObject(event, object);
      }

      return event;
    }
    /**
     * Emit an xAPI event for tracking subscription and messaging activity on a realtime channel.
     */

  }, {
    key: "emitChannelEvent",
    value: function emitChannelEvent(channelName, verb, objectId, objectDefinition) {
      var contextExtensions = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
      var event = this.buildEvent({
        verb: verb,
        contextExtensions: _objectSpread(_objectSpread({}, contextExtensions), {}, {
          'channel-name': channelName
        })
      });
      return event.addObjectId(objectId).addObjectDefinition(objectDefinition.key, objectDefinition.value).emit();
    }
    /**
     * Emit an xAPI event for tracking an update to a class session.
     */

  }, {
    key: "emitClassEvent",
    value: function emitClassEvent(verb) {
      var eventContext = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (!this.captureEvents) {
        return;
      }

      var _this$ampEventsInstan = this.ampEventsInstance.config,
          appName = _this$ampEventsInstan.appName,
          environment = _this$ampEventsInstan.environment;

      var contextExtensions = _objectSpread({
        environment: environment,
        'app-name': appName,
        'live-class-session-id': eventContext.classSessionId,
        'is-custom': eventContext.customContentKey !== undefined,
        'custom-content-id': eventContext.customContentKey
      }, this.contextExtensions || {});

      var resultExtensions = _objectSpread({
        url: typeof window !== 'undefined' ? window.location.href : undefined,
        'class-business-key': eventContext.classKey,
        'cardstack-business-key': eventContext.cardstackKey,
        'chapter-business-key': eventContext.chapterKey,
        'lesson-business-key': eventContext.lessonKey,
        'unit-business-key': eventContext.unitKey,
        'pacing-on': eventContext.pacingMode !== undefined ? eventContext.pacingMode !== 'student' : undefined,
        'pacing-mode': eventContext.pacingMode
      }, this.resultExtensions || {});

      this.buildEvent({
        verb: verb,
        object: _interfaces.xAPIObject.Class,
        contextExtensions: contextExtensions,
        resultExtensions: resultExtensions
      }).emit();
    }
    /**
     * For a given channel, send an event for all messages sent or received, ignoring the normal batch threshold.
     * If channel is unknown, do nothing.
     */

  }, {
    key: "sendAllEventsForChannel",
    value: function sendAllEventsForChannel(channelName) {
      var _this3 = this;

      if (this.messagesPerChannel[channelName]) {
        [_interfaces.xAPIVerb.Sent, _interfaces.xAPIVerb.Received].forEach(function (verb) {
          var messagesByType = _this3.messagesPerChannel[channelName][verb];

          if (messagesByType) {
            Object.entries(messagesByType).forEach(function (_ref2) {
              var _ref3 = (0, _slicedToArray2.default)(_ref2, 2),
                  messageType = _ref3[0],
                  messageCount = _ref3[1];

              if (messageCount !== 0) {
                _this3.sendRealtimeMessageEvent(channelName, verb, messageType, messageCount);
              }
            });
          }
        });
      }
    }
    /**
     * Reset the message counts by triggering an event for each cached channel.
     */

  }, {
    key: "flushMessageCountCache",
    value: function flushMessageCountCache() {
      var _this4 = this;

      Object.keys(this.messagesPerChannel).forEach(function (channel) {
        return _this4.sendAllEventsForChannel(channel);
      });
    }
    /**
     * Check localStorage and restore message counts to their previous state, if cached.
     */

  }, {
    key: "restoreMessageCounts",
    value: function restoreMessageCounts() {
      var cachedMessageCounts = localStorage.getItem(this.stashedCountsKey);

      if (cachedMessageCounts) {
        this.messagesPerChannel = _objectSpread({}, JSON.parse(cachedMessageCounts));
      }
    }
    /**
     * Stash a copy of the current message count in localStorage.
     */

  }, {
    key: "stashMessageCounts",
    value: function stashMessageCounts() {
      localStorage.setItem(this.stashedCountsKey, JSON.stringify(_objectSpread({}, this.messagesPerChannel)));
    }
    /**
     * Wrap a method with try/catch, and log any errors that are thrown.
     */

  }, {
    key: "wrap",
    value: function wrap(originalMethod, methodName) {
      return function () {
        try {
          return originalMethod.apply(void 0, arguments);
        } catch (e) {
          _logger.default.error("Error in xAPIEventService.".concat(methodName), e);

          return undefined;
        }
      };
    }
  }]);
  return XApiEventService;
}();

var _default = new XApiEventService();

exports.default = _default;
//# sourceMappingURL=xApiEventService.js.map